
export default function formatDate (timestamp) {
  const date = new Date(timestamp);

  // Format the date as 01/12/2019
  let day = `${date.getDate()}`;
  if (day.length < 2) {
    day = `0${day}`;
  }
  let month = `${date.getMonth() + 1}`;
  if (month.length < 2) {
    month = `0${month}`;
  }
  let year = date.getFullYear();

  return `${day}/${month}/${year}`;
}
